// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Vr29A","label":"styles_label__YcgJb"};